import { useSSFBehaviors } from 'hooks';
import { usePathname } from 'hooks/usePathname';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { fetchGroupedPositionsConfig } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/constants';
import { FC, useContext, useMemo } from 'react';
import { GroupedPositionsSettingsPageQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

interface IFetchAssignedGroupedPositions {}

export const FetchAssignedGroupedPositionsContext =
  createGQLDataContext<IFetchAssignedGroupedPositions>({});

export const FetchAssignedGroupedPositionsProvider: FC = ({ children }) => {
  const pathname = usePathname();
  const locationId = pathname.split('/')[3];
  const [values, rest] = useSSFBehaviors(fetchGroupedPositionsConfig(locationId));

  const contextValue = useMemo(
    () => ({
      values,
      hasNextPage: !!rest?.data?.groupPositions?.pageInfo?.hasNextPage,
      ...rest,
    }),
    [rest, values],
  );
  return (
    <FetchAssignedGroupedPositionsContext.Provider value={contextValue}>
      {children}
    </FetchAssignedGroupedPositionsContext.Provider>
  );
};

export const useFetchAssignedGroupedPositionsContext =
  (): SSFBehaviorsContextType<GroupedPositionsSettingsPageQuery> & { hasNextPage: boolean } =>
    useContext(FetchAssignedGroupedPositionsContext);
